function normalize(value) {
  return String(value || '').trim();
}

export function getBusinessUnitAccessIds(partnerProfile) {
  const access = Array.isArray(partnerProfile?.business_unit_access)
    ? partnerProfile.business_unit_access
    : [];

  return access
    .map((item) => normalize(item.business_unit_id || item.partner_id))
    .filter(Boolean);
}

export function getParentAdminPartnerIds(partnerProfile) {
  const memberships = Array.isArray(partnerProfile?.memberships)
    ? partnerProfile.memberships
    : [];

  return memberships
    .filter((membership) => (
      membership?.partner_type === 'parent' &&
      membership?.role === 'partner_admin' &&
      membership?.partner_id
    ))
    .map((membership) => normalize(membership.partner_id));
}

export function canManageBusinessUnit(partnerProfile, businessUnitId, parentPartnerId) {
  const normalizedBusinessUnitId = normalize(businessUnitId);
  const normalizedParentPartnerId = normalize(parentPartnerId);
  if (!normalizedBusinessUnitId && !normalizedParentPartnerId) {
    return false;
  }

  const accessIds = new Set(getBusinessUnitAccessIds(partnerProfile));
  if (normalizedBusinessUnitId && accessIds.has(normalizedBusinessUnitId)) {
    return true;
  }

  const parentAdminIds = new Set(getParentAdminPartnerIds(partnerProfile));
  return Boolean(normalizedParentPartnerId && parentAdminIds.has(normalizedParentPartnerId));
}
